import { render } from "./ServicesHero.vue?vue&type=template&id=144f8a3c&scoped=true"
import script from "./ServicesHero.vue?vue&type=script&lang=js"
export * from "./ServicesHero.vue?vue&type=script&lang=js"

import "./ServicesHero.vue?vue&type=style&index=0&id=144f8a3c&scoped=true&lang=css"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144f8a3c"]])

export default __exports__